export default __webpack_public_path__ + "static/media/Major Rune Stone of Ascension.26b5130b.jpg";